// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueLodash from 'lodash'
import VueRouter from './router/index.js'
import VueAnalytics from 'vue-analytics'
import App from './App'
import TopBar from './components/Common/TopBar'
import axios from 'axios';
import VTooltip from 'v-tooltip'
import VueAutosize from 'vue-autosize'
import md5 from 'js-md5';
import VueTour from 'vue-tour'
import moment from 'moment-timezone'
import VueToastr from "vue-toastr";


// import external js files
import './assets/js/min/bootstrap-datepicker-min.js'
import './assets/js/min/bootstrap-min.js'
import './assets/js/min/jquery-min.js'
import './assets/js/min/jquery.ui.js'
import './assets/js/min/j-forms-min.js'

// required to get and set cookie
import {getCookie} from './assets/js/elffy_js/cookie.js'
import {setCookie} from './assets/js/elffy_js/cookie.js'

// bootstrap
import 'bootstrap/scss/bootstrap.scss'
import 'bootstrap'
// AmChart
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'

// template CSS
import "@/frontend-template/css/font-awesome.css";
import "@/frontend-template/css/material-design-iconic-font.css";
import "@/frontend-template/css/bootstrap.css";
import "@/frontend-template/css/animate.css";
import "@/frontend-template/css/layout.css";
import "@/frontend-template/css/components.css";
import "@/frontend-template/css/widgets.css";
import "@/frontend-template/css/plugins.css";
import "@/frontend-template/css/common.css";
import "@/frontend-template/css/pages.css";
import "@/frontend-template/css/bootstrap-extend.css";

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';

/* Dashboard CSS*/
import "@/assets/css/dashboard.css";
/* Deal Page CSS*/
import "@/assets/css/deal.css";
/*Autocomplete CSS*/
import "@/assets/css/autocomplete.css";
/*Autocomplete CSS*/
import "@/assets/css/color.css";

require('vue-tour/dist/vue-tour.css')

//'vue-lodash'
const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional
Vue.use(require('vue-moment'));
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.component('topbar', TopBar)
Vue.use(VTooltip)
Vue.use(VueAutosize)
Vue.use(VueTour)
// axios settings here
Vue.prototype.axios = axios
Vue.prototype.$md5 = md5;

var tz = moment.tz.guess();
moment.tz.setDefault(tz)

// dev api url
//axios.defaults.baseURL = 'http://localhost:3000'

if(window.location.hostname=="localhost"){
  // dev api url
  axios.defaults.baseURL = 'http://localhost:3000'
  // axios.defaults.baseURL = 'https://info.flowneat.com'
}else{
  // production api url
  axios.defaults.baseURL = 'https://info.flowneat.com'
  //axios.defaults.baseURL = 'http://pdf.elffy.cc'
}
// the way to add request header in each request
// axios.defaults.headers.common['Auth-Token'] = 'Auth-Token'

// Vue Validation
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

//vue toastr
Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
});
Vue.config.productionTip = false;
//vue toastr end

const router = VueRouter
const bridge = new Vue()

Vue.use(VueAnalytics, {
  id: 'G-HF2H7XRYVJ',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  render: h => h(App),
  created() {
    this.checkLogin();
  },
  watch: {
    '$route' (to, from) {
      this.checkLogin();
    }
  },
  methods:{
    checkLogin(){
      const vm = this
      if(!getCookie('auth_token')){
        if(["reset_password","verify_email","accept_invitation","signup"].includes(vm.$route.name) ){
          VueRouter.push(vm.$route.fullPath);
        }else{
          VueRouter.push('/login');
        }
      }
      else{
        axios.defaults.headers.common['Auth-Token'] = getCookie('auth_token')
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js